import { render } from "./StakeholderSelectionModal.vue?vue&type=template&id=62afd26a&scoped=true"
import script from "./StakeholderSelectionModal.vue?vue&type=script&lang=js"
export * from "./StakeholderSelectionModal.vue?vue&type=script&lang=js"

import "./StakeholderSelectionModal.vue?vue&type=style&index=0&id=62afd26a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62afd26a"]])

export default __exports__